import { type ApiResponse, ApiFactory } from '@/utils/api'
import { SystemAnnouncementEnum } from '@/constants/enums/api/systemAnnouncement.enum'

export class SystemAnnouncementService extends ApiFactory {
  constructor() {
    super('')
  }

  /** 取得系統公告資料清單 */
  getSystemAnnouncements = async (): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(SystemAnnouncementEnum.systemAnnouncements)
  }

  /** 取得系統公告資料 */
  getSystemAnnouncementDetail = async (params: { id: string }): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(SystemAnnouncementEnum.systemAnnouncement, params)
  }

  /** 取得使用者條款同意狀態 */
  getTermsAgreement = async (): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(SystemAnnouncementEnum.termsAgreement)
  }

  /** 更新使用者條款同意狀態 */
  updateTermsAgreement = async (data: {}): Promise<ApiResponse> => {
    return await this.put<{}, ApiResponse>(SystemAnnouncementEnum.updateTermsAgreement, data)
  }
}
